<template>
  <v-dialog
    v-model="computedHikingTrailVisibility"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar card>
        <!-- close icon -->
        <v-btn icon @click="methodToggleSingleLayer('hiking', 'trails', false)">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>
          <span>{{ computedTrailName }}</span>
        </v-toolbar-title>
      </v-toolbar>
      <div
        style="background-color: black; padding-left: 30px; overflow:auto; -webkit-overflow-scrolling:touch;"
      >
        <v-data-table
          :items="computedHikingTrailGeoJsonFeature"
          :loading="computedHikingTrailsLoading"
          :hide-actions="hideactions"
          :hide-headers="hideheaders"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td>Trail Name</td>
              <td>{{ props.item.properties.name }}</td>
            </tr>
            <tr>
              <td>Mountain</td>
              <td>{{ props.item.properties.mountain }}</td>
            </tr>
            <tr>
              <td>Difficulty Rating</td>
              <td>{{ props.item.properties.diff_rate }}</td>
            </tr>
            <tr>
              <td>Length (km)</td>
              <td>{{ props.item.properties.length_km }}</td>
            </tr>
            <tr>
              <td>Length (mi)</td>
              <td>{{ props.item.properties.length_mi }}</td>
            </tr>
            <tr>
              <td>Travel Time</td>
              <td>{{ props.item.properties.time }}</td>
            </tr>
            <tr>
              <td>Elevation Change</td>
              <td>{{ props.item.properties.elev_chang }}</td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div style="flex: 1 1 auto;"></div>
    </v-card>
  </v-dialog>
</template>

<style scoped>
table {
  padding-top: 20px;
}
</style>
<script>
export default {
  data() {
    return {
      loading: true,
      persistent: false,
      hideheaders: true,
      hideactions: true,
      solo: true
    };
  },
  computed: {
    computedTrailName() {
      if (this.computedHikingTrailVisibility) {
        const trails = this.$store.state.mapLayers.hiking.layers.trails.geojson
          .features;
        // grabs the lift_name of the currently viewed ID
        let result = trails.filter(
          item => item.properties.id == this.computedHikingTrailId
        );
        return result[0].properties.name;
      }
      return [];
    },
    computedHikingTrailGeoJsonFeature() {
      if (this.$store.state.mapLayers.hiking.layers.trails.geojson.features) {
        const trails = this.$store.state.mapLayers.hiking.layers.trails.geojson
          .features;
        const result = trails.filter(
          item => item.properties.id == this.computedHikingTrailId
        );
        return result;
      }
      return [];
    },
    computedHikingTrailVisibility() {
      return this.$store.state.mapLayers.hiking.layers.trails.visibility
        .singleView;
    },
    computedHikingTrailsLoading() {
      return this.$store.state.mapLayers.hiking.layers.trails.loading;
    },
    computedHikingTrailId() {
      return this.$store.state.mapLayers.hiking.layers.trails.visibility
        .singleId;
    },
    computedAuth() {
      return this.$store.state.auth;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    }
  },
  methods: {
    // method to get geojson
    methodGetHikingTrailGeoJson() {
      this.$store.dispatch("actionGetGeoJson", {
        url: "https://api2.alchemymapping.com/vail/whistler/hiking/trails",
        dept: "hiking",
        layer: "trails",
        token: this.computedAuthToken
      });
    }
  },
  watch: {
    // watches the visibility of the list view, and if visible, calls action to get geojson.
    "$store.state.mapLayers.hiking.layers.trails.visibility.singleView": function(
      newValue
    ) {
      if (newValue) {
        this.methodGetHikingTrailGeoJson();
      }
    },
    // after data is loaded, set loading = false to stop loading progress indicator
    "$store.state.mapLayers.hiking.layers.trails.geojson": function(newValue) {
      if (newValue) {
        this.loading = false;
      }
    }
  }
};
</script>
